import React, { useEffect, useState } from 'react';
import '../../styles/user/pendingCaseSubmission.css';
import {
  fetchUserCandidates,
  startCandidateBGC,
  fetchCandidateInfo,
} from '../../services/user/api';
import { RotateCcw, Trash2, Search } from 'lucide-react';
import { FaEye } from 'react-icons/fa';
const PendingCaseSubmissionPage = ({ onViewReportTwo }) => {
  const [candidates, setCandidates] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [submittingBgc, setSubmittingBgc] = useState(null);
  const [selectedCandidateData, setSelectedCandidateData] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [resultModalMessage, setResultModalMessage] = useState('');
  const [showResultModal, setShowResultModal] = useState(false);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search.trim());
      setCurrentPage(0);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);


  useEffect(() => {
    loadCandidates(currentPage);
  }, [currentPage, entriesPerPage,debouncedSearch]);


  const loadCandidates = async (page) => {
    try {
      setLoading(true);
      const response = await fetchUserCandidates(page, entriesPerPage, debouncedSearch);
      if (response?.data?.status) {
        const data = response.data.data;
        const visibleCandidates = (data.content || []).filter(candidate => !candidate.isStartBgc);
        setCandidates(visibleCandidates);
        setTotalElements(data.totalElements || 0);
      } else {
        setFetchError(response.data.message || 'Failed to fetch candidates.');
      }
    } catch (error) {
      console.error('API Error:', error);
      setFetchError('An error occurred while fetching data.');
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const renderSortIcon = (field) => {
    if (sortField !== field) return ' ⇅';
    return sortOrder === 'asc' ? ' ↑' : ' ↓';
  };

  const sortedCandidates = [...candidates].sort((a, b) => {
    if (!sortField) return 0;

    let valA = a[sortField] ?? '';
    let valB = b[sortField] ?? '';


    if (sortField.toLowerCase().includes('date') || sortField.toLowerCase().includes('dob')) {
      valA = new Date(valA);
      valB = new Date(valB);
    }

    else if (sortField.toLowerCase().includes('time')) {
      const timeToSeconds = (t) => {
        if (!t) return 0;
        const [h, m, s = '0'] = t.split(':');
        return parseInt(h) * 3600 + parseInt(m) * 60 + parseInt(s);
      };
      valA = timeToSeconds(valA);
      valB = timeToSeconds(valB);
    }
    // For string columns
    else {
      valA = String(valA).toLowerCase();
      valB = String(valB).toLowerCase();
    }

    if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
    if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });



  const handleRequestForBgc = async (candidateId) => {
    try {
      setSelectedCandidateId(candidateId);
      setShowModal(true);
      setSubmittingBgc(candidateId);

      const response = await startCandidateBGC(candidateId);

      if (response?.data?.success) {

        setCandidates((prev) => prev.filter(c => c.candidateid !== candidateId));
        setTotalElements(prev => prev - 1);
      }

    } catch (error) {
      console.error('Start BGC Error:', error);

    } finally {
      setSubmittingBgc(null);
    }
  };

  const formatDate = (date) => {
    if (!date) return "---";

    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");   
    const month = String(d.getMonth() + 1).padStart(2, "0"); 
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const confirmRequestForBgc = async () => {
    try {
      setSubmittingBgc(selectedCandidateId);
      setShowModal(false);

      const response = await startCandidateBGC(selectedCandidateId);
      if (response?.data?.status) {
        setCandidates((prev) => prev.filter(c => c.candidateid !== selectedCandidateId));
        setTotalElements(prev => prev - 1);
        setResultModalMessage('✅ BGC process started successfully');
      } else {
        setResultModalMessage(response?.data?.message || '❌ Failed to start BGC');
      }
    } catch (error) {
      console.error('Start BGC Error:', error);
      setResultModalMessage('❌ Error starting BGC process');
    } finally {
      setSubmittingBgc(null);
      setShowResultModal(true);
    }
  };


  const handleViewDetails = async (candidateId) => {
    try {
      const response = await fetchCandidateInfo(candidateId);
      if (response?.data?.status) {
        setSelectedCandidateData(response.data.data);
        setShowReportModal(true);
      } else {
        alert(response?.data?.message || 'Failed to fetch candidate info');
      }
    } catch (error) {
      alert('Error fetching candidate details');
    }
  };
  const startIndex = totalElements === 0 ? 0 : currentPage * entriesPerPage + 1;

  const endIndex = totalElements === 0 ? 0 : Math.min((currentPage + 1) * entriesPerPage, totalElements);


  const totalPages = Math.ceil(totalElements / entriesPerPage);

  // const filteredCandidates = sortedCandidates.filter((c) => {
  //   const searchText = search.toLowerCase();

  //   return (
  //     String(c.candidateid || '').toLowerCase().includes(searchText) ||
  //     String(c.fullname || '').toLowerCase().includes(searchText) ||
  //     String(c.email || '').toLowerCase().includes(searchText) ||
  //     String(c.mobileNumber || '').toLowerCase().includes(searchText) ||
  //     String(c.dateOfBirth || '').toLowerCase().includes(searchText) ||
  //     String(c.caseInitiatedDateOnlyAsString || '').toLowerCase().includes(searchText) ||
  //     String(c.caseInitiatedTimeOnly || '').toLowerCase().includes(searchText)
  //   );
  // });


  return (
    <>
      <p className="client-header">Pending Case Submission Candidates</p>

      <div className="client-wrapper">

        <div className="clinet-table-controls">
          <div className="entries-select">
            Show{' '}
            <select
              value={entriesPerPage}
              onChange={(e) => {
                setEntriesPerPage(Number(e.target.value));
                setCurrentPage(0);
              }}
            >
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            {' '}
            entries
          </div>
          <div className="client-search-box">

            <div className="client-search-input-wrapper">
              <input
                id="client-search-input"
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search by any field"
              />
              <Search className="client-search-icon" size={18} />
            </div>
          </div>
        </div>

        <div className="clinet-table-container">
          {loading ? (
            <div className="loading">Loading Candidates...</div>
          ) : fetchError ? (
            <div className="error-message">{fetchError}</div>
          ) : (
            <table className="candidates-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('candidateid')}>
                    Candidate ID {renderSortIcon('candidateid')}
                  </th>
                  <th onClick={() => handleSort('name')}>
                    Name {renderSortIcon('name')}
                  </th>
                  <th onClick={() => handleSort('email')}>
                    Email {renderSortIcon('email')}
                  </th>
                  <th onClick={() => handleSort('mobileNumber')}>
                    Mobile Number {renderSortIcon('mobileNumber')}
                  </th>
                  <th onClick={() => handleSort('dateOfBirth')}>
                    DOB {renderSortIcon('dateOfBirth')}
                  </th>
                  <th onClick={() => handleSort('caseInitiatedDateOnly')}>
                    Case Initiated Date {renderSortIcon('caseInitiatedDateOnly')}
                  </th>
                  <th onClick={() => handleSort('caseInitiatedTimeOnly')}>
                    Case Initiated Time {renderSortIcon('caseInitiatedTimeOnly')}
                  </th>
                  <th>View Details</th>
                  <th>Status</th>

                </tr>
              </thead>
              <tbody>
                {sortedCandidates.length > 0 ? (
                  sortedCandidates.map((candidate) => (
                    <tr key={candidate.candidateid}>
                      <td className="text-purple-600 font-semibold">{candidate.candidateid}</td>
                      <td className="text-blue-700">{candidate.fullname}</td>
                      <td className="text-gray-700">{candidate.email}</td>
                      <td className="text-gray-600">{candidate.mobileNumber}</td>
                      <td className="text-pink-600">{candidate.dateOfBirth}</td>
                      <td>{formatDate(candidate.caseInitiatedDateOnly)}</td>
                      <td>{candidate.caseInitiatedTimeOnly || 'N/A'}</td>
                      <td>
                        <button
                          className="icon-btn text-indigo-600"
                          onClick={() => onViewReportTwo(candidate.candidateid)}
                        >
                          <FaEye />
                        </button>
                      </td>
                      <td>
                        <button
                          className="bgc-request-btn"
                          onClick={() => {
                            setSelectedCandidateId(candidate.candidateid);
                            setShowModal(true);
                          }}
                          disabled={submittingBgc === candidate.candidateid}
                        >
                          {submittingBgc === candidate.candidateid ? 'Processing...' : 'Request for BGC'}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="no-data">No matching candidates found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <p>Are you sure you want to start the BGC process?</p>
              <div className="modal-actions">
                <button className="modal-btn cancel" onClick={() => setShowModal(false)}>No</button>
                <button className="modal-btn confirm" onClick={confirmRequestForBgc}>Yes</button>
              </div>
            </div>
          </div>
        )}
        {showResultModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <p>{resultModalMessage}</p>
              <button className="modal-btn confirm" onClick={() => setShowResultModal(false)}>OK</button>
            </div>
          </div>
        )}

        {totalElements > 0 && (
          <div className="pagination">
            <div className="pagination-summary">
              Showing {currentPage * entriesPerPage + 1} to {Math.min((currentPage + 1) * entriesPerPage, totalElements)} of {totalElements} entries
            </div>

            <div className="pagination-buttons-user">
              <button
                className="page-btn"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                disabled={currentPage === 0}
              >
                ←
              </button>

              <button
                className={`page-btn ${"active"}`}
                onClick={() => setCurrentPage(currentPage)}
              >
                {currentPage + 1}
              </button>

              {currentPage + 1 < totalPages && (
                <button
                  className="page-btn"
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  {currentPage + 2}
                </button>
              )}

              <button
                className="page-btn"
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
                disabled={currentPage === totalPages - 1}
              >
                →
              </button>
            </div>
          </div>
        )}

        {showReportModal && selectedCandidateData && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="close-btn" onClick={() => setShowReportModal(false)}>×</button>
              <h2 className="modal-title">Report</h2>


              <h3>Personal Info</h3>
              <div className="info-grid">

                <div className="info-item">
                  <span className="info-label">First Name:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.firstName || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">Last Name:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.lastName || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">Father's Name:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.fatherName || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">DOB:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.dateOfBirth || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">Email:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.email || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">Gender:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.gender || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">Nationality:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.nationality || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">LinkedIn URL:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.linkedInUrl || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">Mobile Number:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.mobileNumber || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">Alternate Mobile:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.alternateMobileNumber || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">Aadhaar Number:</span>
                  <div className="info-value-box">{selectedCandidateData.personalInfoResponse?.aadhaarCardNumber || '-'}</div>
                </div>
                <div className="info-item">
                  <span className="info-label">Aadhaar Proof:</span>
                  <div className="info-value-box">
                    {selectedCandidateData.personalInfoResponse?.aadhaarProofFileName ? (
                      <a href={selectedCandidateData.personalInfoResponse.aadhaarProofFileName} target="_blank" rel="noopener noreferrer">View</a>
                    ) : ' -'}
                  </div>
                </div>
                <div className="info-item">
                  <span className="info-label">Personal Image:</span>
                  <div className="info-value-box">
                    {selectedCandidateData.personalInfoResponse?.personalImageFileName ? (
                      <a href={selectedCandidateData.personalInfoResponse.personalImageFileName} target="_blank" rel="noopener noreferrer">View</a>
                    ) : ' -'}
                  </div>
                </div>
              </div>


              <h3>Address Info</h3>
              <div className="info-grid">

                <div className="info-item">
                  <span className="info-label">Current Address:</span>
                  <div className="info-value-box">
                    {[
                      selectedCandidateData.addressInfoResponse?.currentAddressLine1,
                      selectedCandidateData.addressInfoResponse?.currentAddressLine2,
                      selectedCandidateData.addressInfoResponse?.currentCity,
                      selectedCandidateData.addressInfoResponse?.currentState,
                      selectedCandidateData.addressInfoResponse?.currentCountry,
                      selectedCandidateData.addressInfoResponse?.currentPinCode
                    ].filter(Boolean).join(', ')}
                  </div>
                </div>
                <div className="info-item">
                  <span className="info-label">Current Address Proof:</span>
                  <div className="info-value-box">
                    {selectedCandidateData.addressInfoResponse?.currentAddressFile ? (
                      <a href={selectedCandidateData.addressInfoResponse.currentAddressFile} target="_blank" rel="noopener noreferrer">View</a>
                    ) : ' -'}
                  </div>
                </div>
                <div className="info-item">
                  <span className="info-label">Permanent Address:</span>
                  <div className="info-value-box">
                    {[
                      selectedCandidateData.addressInfoResponse?.permanentAddressLine1,
                      selectedCandidateData.addressInfoResponse?.permanentAddressLine2,
                      selectedCandidateData.addressInfoResponse?.permanentCity,
                      selectedCandidateData.addressInfoResponse?.permanentState,
                      selectedCandidateData.addressInfoResponse?.permanentCountry,
                      selectedCandidateData.addressInfoResponse?.permanentPinCode
                    ].filter(Boolean).join(', ')}
                  </div>
                </div>
                <div className="info-item">
                  <span className="info-label">Permanent Address Proof:</span>
                  <div className="info-value-box">
                    {selectedCandidateData.addressInfoResponse?.permanentAddressFile ? (
                      <a href={selectedCandidateData.addressInfoResponse.permanentAddressFile} target="_blank" rel="noopener noreferrer">View</a>
                    ) : ' -'}
                  </div>
                </div>
              </div>

              <h3>Education</h3>
              <ul>
                {selectedCandidateData.educationInfos?.length > 0 ? (
                  selectedCandidateData.educationInfos.map((edu, idx) => (
                    <li key={idx} className="mb-2">
                      <div className="info-item">
                        <span className="info-label">Education Level:</span>
                        <div className="info-value-box">{edu.educationLevel}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Institute Name:</span>
                        <div className="info-value-box">{edu.instituteName}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Qualification:</span>
                        <div className="info-value-box">{edu.qualification}</div>
                      </div>
                      {edu.specialization && (
                        <div className="info-item">
                          <span className="info-label">Specialization:</span>
                          <div className="info-value-box">{edu.specialization}</div>
                        </div>
                      )}
                      <div className="info-item">
                        <span className="info-label">Enrolled Year:</span>
                        <div className="info-value-box">{edu.enrolledYear}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Passing Year:</span>
                        <div className="info-value-box">{edu.passingYear}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Location:</span>
                        <div className="info-value-box">
                          {[edu.address, edu.city, edu.stateRegionProvince, edu.country, edu.zipCode].filter(Boolean).join(', ')}
                        </div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Certificate:</span>
                        <div className="info-value-box">
                          {edu.certificateFileUrl ? (
                            <a href={edu.certificateFileUrl} target="_blank" rel="noopener noreferrer">View</a>
                          ) : ' -'}
                        </div>
                      </div>
                    </li>
                  ))
                ) : (
                  <li>No education info available.</li>
                )}
              </ul>

              <h3>Employment</h3>
              <ul>
                {selectedCandidateData.employmentInfos?.length > 0 ? (
                  selectedCandidateData.employmentInfos.map((emp, idx) => (
                    <li key={idx} className="mb-2">
                      <div className="info-item">
                        <span className="info-label">Company:</span>
                        <div className="info-value-box">{emp.companyName} ({emp.employeeCode})</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Job Title:</span>
                        <div className="info-value-box">{emp.jobTitle}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Working From:</span>
                        <div className="info-value-box">{emp.workingFrom}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Working To:</span>
                        <div className="info-value-box">{emp.workingTo}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Location:</span>
                        <div className="info-value-box">{emp.location}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">HR Contact Email:</span>
                        <div className="info-value-box">{emp.hrContactEmail}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">HR Contact Number:</span>
                        <div className="info-value-box">{emp.hrContactNumber}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">UAN Number:</span>
                        <div className="info-value-box">{emp.uanNumber}</div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Offer Letter:</span>
                        <div className="info-value-box">
                          {emp.offerLetterUrl ? (
                            <a href={emp.offerLetterUrl} target="_blank" rel="noopener noreferrer">View</a>
                          ) : ' -'}
                        </div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Experience Letter:</span>
                        <div className="info-value-box">
                          {emp.experienceLetterUrl ? (
                            <a href={emp.experienceLetterUrl} target="_blank" rel="noopener noreferrer">View</a>
                          ) : ' -'}
                        </div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Form 16:</span>
                        <div className="info-value-box">
                          {emp.form16Url ? (
                            <a href={emp.form16Url} target="_blank" rel="noopener noreferrer">View</a>
                          ) : ' -'}
                        </div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Form 26:</span>
                        <div className="info-value-box">
                          {emp.form26Url ? (
                            <a href={emp.form26Url} target="_blank" rel="noopener noreferrer">View</a>
                          ) : ' -'}
                        </div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Bank Statement:</span>
                        <div className="info-value-box">
                          {emp.bankStatementUrl ? (
                            <a href={emp.bankStatementUrl} target="_blank" rel="noopener noreferrer">View</a>
                          ) : ' -'}
                        </div>
                      </div>

                      <div className="info-item salary-slips-info-item">
                        <span className="info-label">Salary Slips:</span>
                        <div className="info-value-box salary-slips-links">
                          {emp.salarySlipsUrl ? emp.salarySlipsUrl.split(',').map((url, index) => (
                            <div key={index}>
                              <a href={url} target="_blank" rel="noopener noreferrer">View Slip {index + 1}</a>
                            </div>
                          )) : ' -'}
                        </div>
                      </div>
                    </li>
                  ))
                ) : (
                  <li>No employment info available.</li>
                )}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PendingCaseSubmissionPage;
